export default __webpack_public_path__ + "static/media/Enkoping_full.691bba92.svg";